import React, { useState, useEffect } from "react";
import { db } from "../firebase-config";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import Profile from "../components/Profile";
import ProjectList from "../components/ProjectList";
import { projectListData } from "../helpers/projectListData";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  gridContainterVariants,
  gridCubeVariants,
} from "../utilities/customHooks";

function Projects() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    const blogRef = collection(db, "blog");
    const q = query(blogRef, orderBy("createdAt", "desc"));
    onSnapshot(q, (snapshot) => {
      const blogs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBlogs(blogs);
      // console.log(blogs);
    });
  });

  return (
    <>
      <Profile />
      <motion.div
        className="box right"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={gridCubeVariants} className="section">
          <h2>
            🎨 <span>Projects</span>
          </h2>
        </motion.div>
        <div className="projects" style={{ display: "none" }}>
          {blogs.length === 0 ? (
            <p>No Project.</p>
          ) : (
            blogs.map(({ id, title, description, imageUrl, createdAt }) => (
              <motion.div
                variants={gridCubeVariants}
                className="project"
                key={id}
              >
                <div className="desc">
                  <h4>{title}</h4>
                  <p>{description}</p>
                  <a
                    className="btn cta"
                    onClick={() => {
                      navigate("/project/" + id);
                    }}
                  >
                    {/* <span className="vertical"></span>
                    <span className="horizontal"></span>View Details */}
                    View Details
                  </a>
                </div>
                <p>{createdAt.toDate().toLocaleDateString()}</p>
                <img
                  src={imageUrl}
                  alt="Image"
                  style={{ height: 100, width: 100 }}
                />
              </motion.div>
            ))
          )}
        </div>
        <div className="projects">
          {projectListData.map((project, index) => {
            return (
              <ProjectList
                key={index}
                id={index}
                name={project.name}
                content={project.content}
                image={project.image}
                tags={project.tags}
              />
            );
          })}
        </div>
      </motion.div>
    </>
  );
}

export default Projects;
